import {hot} from 'react-hot-loader';
import React from 'react';
import {IntlProvider} from 'react-intl';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import {connect, Provider} from 'react-redux';
import messages from '../../res/translations';

import Instance from './instance/Instance';
import Survey from './Survey';
import Home from './Home';

const IntlProviderWrapper = ({children, locale}) => (
    <IntlProvider locale={locale} messages={messages[locale] || messages['en']}>
        {children}
    </IntlProvider>
);

const ConnectedIntlProvider = connect((state) => ({locale: state.language.current}))(IntlProviderWrapper);

// eslint-disable-next-line react/no-multi-comp
const App = ({store}) => {
    return (
        <Provider store={store}>
            <ConnectedIntlProvider>
                <Router>
                    <Switch>
                        <Route path="/instance/:id" component={Instance} />
                        <Route path="/survey/tracked/:trackerCode" component={Survey} />
                        <Route path="/survey/:id" component={Survey} />
                        <Route path="/" exact component={Home} />
                        <Redirect to="/" />
                    </Switch>
                </Router>
            </ConnectedIntlProvider>
        </Provider>
    );
};

export default hot(module)(App);
